<template>
  <JurnalList jenisJurnal="9" :title="title"  :routeInput="input" :routeEdit="edit" />
</template>

<script>
import JurnalList from '@/views/jurnal/JurnalList.vue';

export default {
    components: {
        JurnalList
    },
    data:() => ({
       title : 'Jurnal Rekening Non Air (JRNA)',
       input : 'jrnainput',
       edit : 'jrnaedit'
    }),
    methods: {
       
    }
}
</script>


<style>

</style>